module.exports = __webpack_public_path__ + "static/media/tom_cole_pic_8.c218b0f0.jpg";